import { CheckHistoryTypes } from './check-history-types';

/**
 * History entry types that represent a distinct candidate/referee email send and therefore get
 * the "View email template" action. Only these 6 slugs support a brand-linked custom template
 * (see `EmailTemplateEnum::TYPE_ENUM` on the backend) — the rest always fetch the Postmark default.
 */
export const HISTORY_TYPE_TO_EMAIL_TEMPLATE_TYPE = {
  [CheckHistoryTypes.RequestSentCandidate]: 'candidate_request',
  [CheckHistoryTypes.AdditionalChecksRequestSent]: 'new_checks_added',
  [CheckHistoryTypes.BundleCheckAdded]: 'new_checks_added',
  [CheckHistoryTypes.RefereeRequestSent]: 'new_referee_nomination',
  [CheckHistoryTypes.RefereeReplacement]: 'replace_referee',
  [CheckHistoryTypes.RequestSentReferee]: 'new_request_to_referee',
  [CheckHistoryTypes.CandidatePortalInvitationSent]: 'candidate_portal_invitation',
  [CheckHistoryTypes.ReminderCandidate]: 'candidate_request_reminder',
  [CheckHistoryTypes.ReminderReferee]: 'referee_reminder',
  [CheckHistoryTypes.CandidateRefereeBackupRequest]: 'candidate_backup',
  [CheckHistoryTypes.CandidateDocumentRequestSent]: 'candidate_document_request',
  [CheckHistoryTypes.ReConsentRequested]: 'candidate_re_consent',
  [CheckHistoryTypes.CheckDeclined]: 'candidate_background_rejected',
};

/** `check_history.type` may arrive as a string from JSON; coerce before lookup. */
export function emailTemplateTypeForHistoryEntry(type) {
  if (type === null || type === undefined) return null;
  if (HISTORY_TYPE_TO_EMAIL_TEMPLATE_TYPE[type]) return HISTORY_TYPE_TO_EMAIL_TEMPLATE_TYPE[type];
  const n = Number(type);
  return Number.isFinite(n) ? (HISTORY_TYPE_TO_EMAIL_TEMPLATE_TYPE[n] ?? null) : null;
}
